import { DateTime } from 'luxon'

declare const ShiftActivityIDSymbol: unique symbol
export type ShiftActivityID = string & { [ShiftActivityIDSymbol]: never }

export interface ShiftActivityDto {
    id: string

    subject_id?: string,
    subject_type?: string,

    causer_id?: string,
    causer_type?: string,

    log_name?: string,
    description?: string,

    event?: string,

    properties?: string,

    created_at: string

    message?: string

    causer?: {
        data: {
            id: string,
            first_name: string,
            last_name: string
        }
    }
}

export interface ShiftActivity {
    id: ShiftActivityID

    subject_id?: string
    subject_type?: string

    causer_id?: string
    causer_type?: string

    log_name?: string
    description?: string

    event?: string

    properties?: string

    createdAt: DateTime

    message?: string

    causer?: {
        id: string,
        firstName: string,
        lastName: string
    }
}

export const createShiftActivity = (
    params: {
        id: ShiftActivityID

        subject_id?: string,
        subject_type?: string,

        causer_id?: string,
        causer_type?: string,

        log_name?: string,
        description?: string,

        event?: string,

        properties?: string,

        createdAt: DateTime,

        message?: string,

        causer?: {
            id: string,
            firstName: string,
            lastName: string
        }
    }
): ShiftActivity => ({
    id: params.id,

    subject_id: params.subject_id,
    subject_type: params.subject_type,

    causer_id: params.causer_id,
    causer_type: params.causer_type,

    log_name: params.log_name,
    description: params.description,

    event: params.event,

    properties: params.properties,

    createdAt: params.createdAt,

    message: params.message,

    causer: params.causer
})

export const shiftActivityFromDto = (dto: ShiftActivityDto): ShiftActivity => (createShiftActivity({
    id: dto.id as ShiftActivityID,

    subject_id: dto.subject_id,
    subject_type: dto.subject_type,

    causer_id: dto.causer_id,
    causer_type: dto.causer_type,

    log_name: dto.log_name,
    description: dto.description,

    event: dto.event,

    properties: dto.properties,

    createdAt: DateTime.fromISO(dto.created_at),

    message: dto.message,

    causer: dto.causer ? {
        id: dto.causer.data.id,
        firstName: dto.causer.data.first_name,
        lastName: dto.causer.data.last_name
    } : undefined
}))